const cardsData = [
  {
    title: '香蕉视频 — 海量资源每日上新',
    desc: '作为行业头部平台，香蕉视频持续保持高频更新节奏，覆盖动作、剧情、悬疑等多元题材，高清片源占比超90%，播放体验稳定流畅，是用户首选观影入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20abstract%20digital%20illustration%20representing%20entertainment%20and%20cinema%2C%20soft%20coral%20and%20golden%20gradients%2C%20flowing%20curved%20shapes%20evoking%20film%20reels%20and%20creativity%2C%20modern%20minimalist%20style%20with%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-xj-2026&orientation=landscape',
    tag: '头部平台',
  },
  {
    title: '红桃视频 — 独家原创内容首发',
    desc: '红桃视频以原创独家内容为核心竞争力，拥有专业制作团队与IP孵化能力，多部原创系列累计观看超千万次，在同类平台中口碑与辨识度兼具。',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20abstract%20digital%20artwork%20with%20warm%20amber%20and%20rose%20tones%2C%20layered%20geometric%20shapes%20representing%20creativity%20and%20original%20content%2C%20soft%20gradient%20depth%2C%20modern%20editorial%20design%20aesthetic%2C%20no%20text%20no%20people&width=800&height=500&seq=card-ht-2026&orientation=landscape',
    tag: '原创精品',
  },
  {
    title: '91视频 — 社区互动与高口碑',
    desc: '91视频凭借活跃的用户社区和高互动率脱颖而出，用户评分体系真实透明，社区氛围良好，内容发现效率高，是探索新内容的优质渠道。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20abstract%20illustration%20with%20warm%20terracotta%20and%20cream%20colors%2C%20interconnected%20circular%20shapes%20symbolizing%20community%20and%20interaction%2C%20soft%20gradient%20background%2C%20contemporary%20minimalist%20design%2C%20no%20text%20no%20people&width=800&height=500&seq=card-91-2026&orientation=landscape',
    tag: '社区热门',
  },
  {
    title: '蜜桃视频 — 极致高清不缓冲体验',
    desc: '蜜桃视频在播放技术方面持续投入，采用先进的CDN加速与自适应码率技术，在各类网络环境下均能保持流畅播放，真正做到观影不缓冲。',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20abstract%20digital%20composition%20with%20peach%20and%20soft%20gold%20gradients%2C%20smooth%20flowing%20lines%20representing%20streaming%20technology%20and%20speed%2C%20minimalist%20design%20with%20depth%2C%20contemporary%20aesthetic%2C%20no%20text%20no%20people&width=800&height=500&seq=card-mt-2026&orientation=landscape',
    tag: '技术领先',
  },
  {
    title: '樱桃视频 — 小而美的精致平台',
    desc: '樱桃视频走精品化路线，内容虽少但精，每部作品都经过严格筛选，画质与内容质量均为上乘，适合追求品质观影体验的用户群体。',
    image: 'https://readdy.ai/api/search-image?query=A%20delicate%20abstract%20artwork%20with%20soft%20cherry%20blossom%20pink%20and%20warm%20cream%20tones%2C%20minimalist%20geometric%20shapes%20evoking%20elegance%20and%20quality%2C%20refined%20composition%20with%20gentle%20gradients%2C%20no%20text%20no%20people&width=800&height=500&seq=card-yt-2026&orientation=landscape',
    tag: '精品推荐',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            编辑精选
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            根据内容质量、播放体验与用户口碑精心筛选的优质影视平台推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, idx) => (
            <article
              key={idx}
              className={`group bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-300 overflow-hidden cursor-pointer ${
                idx === 0 ? 'lg:col-span-3' : ''
              }`}
            >
              <div className={`flex ${idx === 0 ? 'flex-col lg:flex-row' : 'flex-col'}`}>
                <div className={`relative overflow-hidden bg-background-100 ${
                  idx === 0 ? 'w-full lg:w-2/5 aspect-[16/9] lg:aspect-auto lg:min-h-[240px]' : 'aspect-[16/10]'
                }`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className={`p-5 flex flex-col justify-center ${idx === 0 ? 'lg:w-3/5' : ''}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium">
                      {card.tag}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}